import { useState, useMemo, useCallback } from 'react';
import { FacetFieldConfig } from '../types';

export const usePinnedFacets = <TEntity>(
    config: FacetFieldConfig<TEntity>[],
    initialPinnedKeys: string[],
) => {
    const [pinnedKeys, setPinnedKeys] = useState<string[]>(initialPinnedKeys);

    const visibleConfig = useMemo(() => {
        return config.filter((item) => pinnedKeys.includes(item.key));
    }, [config, pinnedKeys]);

    const masterConfig = useMemo(() => {
        return config.filter((item) => !pinnedKeys.includes(item.key));
    }, [config, pinnedKeys]);

    const pin = useCallback((key: string) => {
        setPinnedKeys((prev) => Array.from(new Set([...prev, key])));
    }, []);

    const unpin = useCallback((key: string) => {
        setPinnedKeys((prev) => prev.filter((k) => k !== key));
    }, []);

    return {
        visibleConfig,
        masterConfig,
        pinnedKeys,
        pin,
        unpin,
    };
};
